// Shared MUI TextField/Select styling so form fields on editorial pages
// (Membership, ContactUs, DonateNow, ...) share one visual language
// instead of each page redefining the same sx object.
export const editorialInputSx = {
  '& .MuiInputBase-root': {
    fontFamily: 'var(--font-body)',
    background: 'transparent',
    borderRadius: 0,
  },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(36,34,88,0.18)' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--navy-500)' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--teal-500) !important',
    borderWidth: '1px !important',
  },
  '& .MuiInputLabel-root': {
    fontFamily: 'var(--font-mono)',
    fontSize: 12,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: 'var(--navy-300)',
  },
  '& .Mui-focused.MuiInputLabel-root': { color: 'var(--teal-500)' },
  '& input, & textarea': {
    color: 'var(--navy-700)',
    fontFamily: 'var(--font-body)',
    fontSize: 16,
  },
};
